import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Icon } from '../../atoms';
import { DropdownMenuItem } from '../DropdownMenuItem';
import { Dropdown } from '../../organisms/Dropdown';

const DropdownToggle = styled(Icon)`
  cursor: pointer;
`;
const NavigationItemActionsDropdown = ({
  onDeleteConversation,
  onRenameConversation,
  actionLabel = 'Delete'
}) => {
  const handleRenameConversation = (e) => {
    e.preventDefault();
    onRenameConversation();
  };
  const handleDeleteConversation = (e) => {
    e.preventDefault();
    onDeleteConversation();
  };
  return (
    <Dropdown
      menuPlacement='bottom-start'
      menuStyle={{ width: 140 }}
      toggleComponent={<DropdownToggle name='ellipsis' displaySize={20} />}
    >
      {() => (
        <>
          <DropdownMenuItem
            onClick={handleRenameConversation}
            leftIcon={<Icon displaySize={20} name='pencil' color='var(--content-subtitle)' />}
          >
            Rename
          </DropdownMenuItem>
          <DropdownMenuItem
            color='var(--critical-default)'
            leftIcon={<Icon displaySize={20} name='trash' color='var(--critical-default)' />}
            onClick={handleDeleteConversation}
          >
            {actionLabel}
          </DropdownMenuItem>
        </>
      )}
    </Dropdown>
  );
};

NavigationItemActionsDropdown.propTypes = {
  onDeleteConversation: PropTypes.func.isRequired,
  onRenameConversation: PropTypes.func.isRequired,
  actionLabel: PropTypes.string
};

export { NavigationItemActionsDropdown };
